<button [style.background]="color" type="button" (click)="open()">
      <i class="material-icons">shopping_cart</i>
      <span>Adicionar ao Carrinho</span> 
</button>      
